import { createTransform } from 'redux-persist';

const getInformationToPersist = (state, key) => {
  switch (key) {
    case 'authentication':
      const { accessToken, expiresAt, loggedIn, expiresIn } = state;
      return { accessToken, expiresAt, loggedIn, expiresIn };
    default:
      return null;
  }
};

const customTransform = createTransform(getInformationToPersist, getInformationToPersist);

// return a redux-persist config
export default {
  transforms: [customTransform],
  whitelist: ['authentication'],
  keyPrefix: 'webclient'
};



// WEBPACK FOOTER //
// ./src/app/app.persists.js